/**
 An object which flashes a given element.  Once instantiated the element will
 begin flashing.  Usage example:

 new ElementFlasher(document.getElementById("mySpan"), 3, "normal",
 "bright", 250);
 */
export class ElementFlasher {
    constructor(elm, nTimes, offClassName, onClassName, pauseMs) {
        this.elm = elm;
        this.nTimes = nTimes;
        this.onClassName = onClassName;
        this.offClassName = offClassName;
        this.pauseMs = pauseMs;
        this.timeoutHandle = null;
    }

    start() {
        this._flash_tick();
    }

    stop() {
        clearTimeout(this.timeoutHandle);
        this.elm.className = this.onClassName;
        this.nTimes = 0;
    }

    _flash_tick() {
        let self = this;

        //need to turn it on?
        if (this.elm.className == this.offClassName) {
            this.nTimes--;
            this.elm.className = this.onClassName;

            this.timeoutHandle = window.setTimeout(function() {self._flash_tick();}, this.pauseMs);
        } else { // Turn off
            this.elm.className = this.offClassName;
            if (this.nTimes > 0)
                this.timeoutHandle = setTimeout(function() {self._flash_tick();}, this.pauseMs);
        }
    }
}